import React, {useEffect, useState } from "react";
import { getMyAppraisals } from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertError } from "../../utils/alerts";

export default function Appraisals() {
    const [loading, setLoading] = useState(false);
    const [appraisals, setMyAppraisals] = useState(null);
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        getMyAppraisals()
            .then((res) => { 
                if(res.data.success){
                    setMyAppraisals(res.data.data);  
                }else {
                    alertError(res.data.message)
                }
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => { 
                console.log(err.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    return (
        <>
            <div className="spur-card-menu"><Link to="/performance/newappraisal" className="pull-right btn topbtn btn-primary">NEW APPRAISAL</Link></div>
            
            <h1 className="dash-title">Performance Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Appraisals</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && appraisals && appraisals) ? 
                                    <div className="table-responsive">
                                        {(appraisals && appraisals.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Employee</th><th>Team</th><th>Appraisal Cycle</th><th>Year</th> <th>Month</th><th>Date Created</th>
                                            <th>Status</th><th>View</th></tr></thead>
                                            <tbody>
                                                {appraisals && appraisals.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.employee?.first_name && row?.employee?.first_name} {row?.employee?.last_name && row?.employee?.last_name}</td>
                                                        <td>{row?.employee_team?.team_name && row?.employee_team?.team_name}</td>
                                                        <td>{row?.appraisal_cycle && row?.appraisal_cycle}</td>
                                                        <td>{row?.year && row?.year}</td>
                                                        <td>{row?.month && row?.month}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>{row?.status && row?.status}</td>
                                                        <td>
                                                            <button 
                                                                name='view_employee' 
                                                                onClick={() => navigateById("/performance/appraisal", row._id)} 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">You have not created any appraisal yet.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
